import { render, staticRenderFns } from "./AppListIframe.vue?vue&type=template&id=91815be4&"
import script from "./AppListIframe.vue?vue&type=script&lang=ts&"
export * from "./AppListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports